import React, { useState } from "react";
import {
  TableRow,
  TableCell,
  Box,
  Typography,
  Avatar,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";  
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomCheckbox from "../../components/CustomCheckbox";

const cellStyle = {
  padding: "10px 16px",
};

const getInitials = (name) => {
  const names = name.split(" ");
  return names.map((n) => n[0]).join("").toUpperCase();
};

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${hash % 360}, 60%, 60%)`;
};

const ManualRow = ({
  row,
  isSelected,
  onSelectToggle,
  isActiveCell = false,
  isArchivedCell = false
}) => {
  const [anchorEls, setAnchorEls] = useState({});

  const handleClick = (event, id) => {
    setAnchorEls((prev) => ({ ...prev, [id]: event.currentTarget }));
  };

  const handleClose = (id) => {
    setAnchorEls((prev) => ({ ...prev, [id]: null }));
  };

  const renderStatusButton = () => {
    if (row.status === "Free") {
      return (
        <Button
          sx={{
            background: "rgba(56, 183, 88, 0.10)",
            color: "#38B758",
            fontSize: "13px",
            textTransform: "capitalize",
          }}
        >
          Free
        </Button>
      );
    }
    if (row.status === "Starter") {
      return (
        <Button
          sx={{
            background: "rgba(111, 0, 253, 0.10)",
            color: "#6F00FD",
            fontSize: "13px",
            textTransform: "capitalize",
          }}
        >
          Starter
        </Button>
      );
    } 
    return null;
  };

  return (
    <TableRow
      sx={{
        "&:hover": { boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)" },
        backgroundColor: "#fff",
        borderRadius: "10px",
        transition: "box-shadow 0.3s ease",
      }}
    >
      <TableCell
        sx={{
          ...cellStyle,
          border: "none",
          minWidth: "32px",
          maxWidth: "32px",
          borderRadius: "10px 0 0 10px",
        }}
      >
        <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
      </TableCell>

      <TableCell fontSize="small" sx={{ ...cellStyle, border: "none" }}>{row.id}</TableCell>

      {isActiveCell && (<TableCell fontSize="small" sx={{ ...cellStyle, border: "none", textAlign: "center" }}>
        {row.DayMonYear}
      </TableCell>)}

      <TableCell sx={{ ...cellStyle, border: "none", textAlign: "left" }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar
            src={row.memberAvatar}
            sx={{
              width: "40px",
              height: "40px",
              fontSize: "13px",
              backgroundColor: row.memberAvatar
                ? "transparent"
                : stringToColor(row.memberName),
            }}
          >
            {!row.memberAvatar && getInitials(row.memberName)}
          </Avatar>
          <Box>
            <Typography fontWeight="bold" sx={{ whiteSpace: "nowrap", fontSize:'14px' }}>
              {row.memberName}
            </Typography>
            <Typography fontSize="small"
              variant="body2"
              color="text.secondary"
              sx={{ whiteSpace: "nowrap", fontSize:'12px' }}
            >
              {row.memberRole}
            </Typography>
          </Box>
        </Box>
      </TableCell>

      {isActiveCell && (<TableCell fontSize="small" sx={{ ...cellStyle, border: "none", textAlign: "center" }}>
        {renderStatusButton()}
      </TableCell>)}

    {isActiveCell && (  <TableCell fontSize="small"
        sx={{
          ...cellStyle,
          border: "none",
          textAlign: "center",
          borderRadius: "0px 10px 10px 0px",
        }}
      >
        <Box sx={{display:'flex', justifyContent:'flex-end', alignItems:'center', gap:1.5}}>
          <IconButton 
            sx={{
              background: "#0076FE",
              color: "#fff",
              fontSize: "13px",
              borderRadius: "30px",
              padding: "4px 16px",
              fontWeight: "500", 
              '&:hover': {
                background: "#0056b3",
              },
              transition: 'background-color 0.3s ease',
            }}
          >
            Choose Plan  
          </IconButton>
          <IconButton
            onClick={(e) => handleClick(e, row.id)}
            sx={{
              border: "1px solid #0076FE",
              color: "#0076FE",
              fontSize: "13px",
              borderRadius: "30px",
              padding: "3px 16px",
              fontWeight: "500",
            }}
          >
            Action <KeyboardArrowDownIcon sx={{ marginLeft: "10px" }} />
          </IconButton>
        </Box>
        <Menu
          anchorEl={anchorEls[row.id]}
          open={Boolean(anchorEls[row.id])}
          onClose={() => handleClose(row.id)}
          sx={{ borderRadius: "12px" }}
        >
          <MenuItem
            sx={{ fontSize: "14px", color: "#1A1F36" }}
            onClick={() => handleClose(row.id)}
          >
            Edit 
          </MenuItem>
          <MenuItem
            sx={{ fontSize: "14px", color: "#1A1F36" }}
            onClick={() => handleClose(row.id)}
          >
            Delete
          </MenuItem> 
        </Menu>
      </TableCell>)}
    {isArchivedCell && (  <TableCell
        sx={{
          ...cellStyle,
          border: "none",
          textAlign: "center",
          borderRadius: "0px 10px 10px 0px",
        }}
      >
        <IconButton 
            sx={{
              border: "1px solid #0076FE",
              color: "#0076FE",
              fontSize: "13px",
              borderRadius: "30px",
              padding: "4px 16px",
              fontWeight: "500", 
              '&:hover': {
                background: "#0056b3",
				color:'#fff'
              },
              transition: 'background-color 0.3s ease',
            }}
          >
           Restore 
          </IconButton>
      </TableCell>)}
    </TableRow>
  );
};

export default ManualRow;